// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Application Popup Modal Styles
   ========================================== */

.fintech-application-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(3, 7, 18, 0.88);
  backdrop-filter: blur(12px);
  box-sizing: border-box;
}

.popup-apply-container {
  position: relative;
  background: rgba(15, 23, 42, 0.98);
  backdrop-filter: blur(24px);
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 20px;
  width: 100%;
  max-width: 680px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 65px rgba(0, 0, 0, 0.85), 0 0 45px rgba(245, 158, 11, 0.18);
  animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  box-sizing: border-box;
}

/* Custom Scrollbar */
.popup-apply-container::-webkit-scrollbar {
  width: 6px;
}
.popup-apply-container::-webkit-scrollbar-track {
  background: rgba(15, 23, 42, 0.5);
}
.popup-apply-container::-webkit-scrollbar-thumb {
  background: rgba(245, 158, 11, 0.4);
  border-radius: 10px;
}

@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.fintech-application-header {
  padding: 1.25rem 1.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(11, 15, 23, 0.5);
  position: sticky;
  top: 0;
  z-index: 10;
}

.fintech-application-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.fintech-application-close {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #94a3b8;
  border-radius: 50%;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;
}

.fintech-application-close:hover {
  background: rgba(245, 158, 11, 0.2);
  border-color: #f59e0b;
  color: #ffffff;
}

.popup-apply-body {
  padding: 1.5rem 1.75rem 2rem;
}

.popup-subtext {
  color: #94a3b8;
  font-size: 0.9rem;
  margin: 0 0 1.25rem 0;
  line-height: 1.5;
}

.email-highlight {
  color: #f59e0b;
  font-weight: 600;
  text-decoration: underline;
}

.popup-form {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.popup-form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.1rem;
}

.popup-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.popup-field.full-width {
  grid-column: span 2;
}

.popup-field label {
  color: #e2e8f0;
  font-size: 0.85rem;
  font-weight: 600;
}

.popup-input,
.popup-select,
.popup-textarea {
  width: 100%;
  background: rgba(11, 15, 23, 0.8) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  color: #ffffff !important;
  padding: 0.75rem 1rem !important;
  border-radius: 10px !important;
  font-size: 0.92rem !important;
  box-sizing: border-box;
  transition: all 0.2s ease;
  outline: none;
}

.popup-input:focus,
.popup-select:focus,
.popup-textarea:focus {
  border-color: rgba(245, 158, 11, 0.6) !important;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15) !important;
}

.popup-select option {
  background: #0f172a;
  color: #ffffff;
}

.popup-textarea {
  resize: vertical;
  min-height: 80px;
}

.popup-submit-btn {
  width: 100%;
  margin-top: 0.5rem;
  padding: 0.9rem 1.5rem;
  font-size: 0.98rem;
  font-weight: 800;
  color: #0f172a;
  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 18px rgba(245, 158, 11, 0.3);
}

.popup-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.45);
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
}

.popup-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Success Alert Box */
.success-alert-box {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.3);
  border-radius: 14px;
  padding: 1.5rem;
  text-align: center;
  margin: 1rem 0;
}

.success-title {
  color: #34d399;
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.success-desc {
  color: #cbd5e1;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1.25rem;
}

.btn-close-modal {
  padding: 0.65rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.2);
}

@media (max-width: 640px) {
  .popup-apply-container {
    max-height: 95vh;
    border-radius: 16px;
  }
  .popup-form-grid {
    grid-template-columns: 1fr;
    gap: 0.9rem;
  }
  .popup-field.full-width {
    grid-column: span 1;
  }
  .popup-apply-body {
    padding: 1.25rem 1rem 1.5rem;
  }
  .fintech-application-header {
    padding: 1rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/ApplicationForm.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8EAA8E;EAC9E,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,wBAAwB;EACxB,kDAAkD;EAClD,iCAAiC;EACjC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,4CAA4C;EAC5C,sDAAsD;EACtD,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,gDAAgD;EAChD,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu Application Popup Modal Styles\n   ========================================== */\n\n.fintech-application-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(3, 7, 18, 0.88);\n  backdrop-filter: blur(12px);\n  box-sizing: border-box;\n}\n\n.popup-apply-container {\n  position: relative;\n  background: rgba(15, 23, 42, 0.98);\n  backdrop-filter: blur(24px);\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  border-radius: 20px;\n  width: 100%;\n  max-width: 680px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 65px rgba(0, 0, 0, 0.85), 0 0 45px rgba(245, 158, 11, 0.18);\n  animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  box-sizing: border-box;\n}\n\n/* Custom Scrollbar */\n.popup-apply-container::-webkit-scrollbar {\n  width: 6px;\n}\n.popup-apply-container::-webkit-scrollbar-track {\n  background: rgba(15, 23, 42, 0.5);\n}\n.popup-apply-container::-webkit-scrollbar-thumb {\n  background: rgba(245, 158, 11, 0.4);\n  border-radius: 10px;\n}\n\n@keyframes modalSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.fintech-application-header {\n  padding: 1.25rem 1.75rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(11, 15, 23, 0.5);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.fintech-application-header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.fintech-application-close {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #94a3b8;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.fintech-application-close:hover {\n  background: rgba(245, 158, 11, 0.2);\n  border-color: #f59e0b;\n  color: #ffffff;\n}\n\n.popup-apply-body {\n  padding: 1.5rem 1.75rem 2rem;\n}\n\n.popup-subtext {\n  color: #94a3b8;\n  font-size: 0.9rem;\n  margin: 0 0 1.25rem 0;\n  line-height: 1.5;\n}\n\n.email-highlight {\n  color: #f59e0b;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.popup-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n\n.popup-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.1rem;\n}\n\n.popup-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.popup-field.full-width {\n  grid-column: span 2;\n}\n\n.popup-field label {\n  color: #e2e8f0;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.popup-input,\n.popup-select,\n.popup-textarea {\n  width: 100%;\n  background: rgba(11, 15, 23, 0.8) !important;\n  border: 1px solid rgba(255, 255, 255, 0.12) !important;\n  color: #ffffff !important;\n  padding: 0.75rem 1rem !important;\n  border-radius: 10px !important;\n  font-size: 0.92rem !important;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.popup-input:focus,\n.popup-select:focus,\n.popup-textarea:focus {\n  border-color: rgba(245, 158, 11, 0.6) !important;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15) !important;\n}\n\n.popup-select option {\n  background: #0f172a;\n  color: #ffffff;\n}\n\n.popup-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.popup-submit-btn {\n  width: 100%;\n  margin-top: 0.5rem;\n  padding: 0.9rem 1.5rem;\n  font-size: 0.98rem;\n  font-weight: 800;\n  color: #0f172a;\n  background: linear-gradient(135deg, #f59e0b 0%, #ea580c 100%);\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 18px rgba(245, 158, 11, 0.3);\n}\n\n.popup-submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(245, 158, 11, 0.45);\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n}\n\n.popup-submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Success Alert Box */\n.success-alert-box {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  border-radius: 14px;\n  padding: 1.5rem;\n  text-align: center;\n  margin: 1rem 0;\n}\n\n.success-title {\n  color: #34d399;\n  font-size: 1.15rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n}\n\n.success-desc {\n  color: #cbd5e1;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  margin-bottom: 1.25rem;\n}\n\n.btn-close-modal {\n  padding: 0.65rem 1.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-close-modal:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n@media (max-width: 640px) {\n  .popup-apply-container {\n    max-height: 95vh;\n    border-radius: 16px;\n  }\n  .popup-form-grid {\n    grid-template-columns: 1fr;\n    gap: 0.9rem;\n  }\n  .popup-field.full-width {\n    grid-column: span 1;\n  }\n  .popup-apply-body {\n    padding: 1.25rem 1rem 1.5rem;\n  }\n  .fintech-application-header {\n    padding: 1rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
